import styled from "styled-components";

import { Link } from "react-router-dom";
import FallbackImage from "components/global/FallbackImage";

export const DashboardSecondaryButton = styled.button.attrs({
  className:
    "rounded-2xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-4 py-3 text-sm font-medium text-[var(--brand-ink)] transition hover:border-[var(--brand-highlight)] hover:bg-[rgba(240,191,86,0.08)]",
})``;

export const DashboardPrimaryButton = styled.button.attrs({
  className:
    "rounded-2xl bg-[var(--brand-accent)] px-4 py-3 text-sm font-medium text-white transition hover:bg-[var(--brand-accent-deep)]",
})``;

export const DashboardGridLayout = styled.div.attrs({
  className: "grid gap-5 md:grid-cols-2 xl:grid-cols-4",
})``;

export const DashboardGridLayoutSecondary = styled.div.attrs({
  className: "mt-8 grid gap-6 xl:grid-cols-[1.3fr_1fr]",
})``;

export const DashboardActionLink = styled(Link).attrs({
  className: "inline-flex items-center gap-2 text-sm font-medium text-[var(--brand-highlight)]",
})``;

export const DashboardActionButton = styled.button.attrs({
  className:
    "inline-flex items-center gap-2 border-0 bg-transparent p-0 text-sm font-medium text-[var(--brand-highlight)]",
})``;

export const DashboardInfoRow = styled.div.attrs({ className: "flex items-center gap-3" })``;

export const DashboardThumbnailImage = styled(FallbackImage).attrs({
  className: "h-12 w-12 rounded-2xl",
})``;

export const DashboardLabelText = styled.p.attrs({
  className: "font-medium text-[var(--brand-ink)]",
})``;

export const DashboardMetaText = styled.p.attrs({
  className: "text-xs text-[var(--brand-muted)]",
})``;

export const DashboardGridLayoutTertiary = styled.div.attrs({
  className: "grid gap-4 sm:grid-cols-2",
})``;

export const DashboardSection = styled.div.attrs({ className: "brand-panel-muted" })``;

export const DashboardIconBadge = styled.span.attrs({
  className:
    "flex h-11 w-11 items-center justify-center rounded-2xl bg-[var(--brand-bg)] text-[var(--brand-accent-deep)]",
})``;

export const DashboardMetaTextSecondary = styled.p.attrs({
  className: "text-sm text-[var(--brand-muted)]",
})``;

export const DashboardIconBadgeSecondary = styled.span.attrs({
  className:
    "flex h-11 w-11 items-center justify-center rounded-2xl bg-[var(--brand-bg)] text-[var(--brand-highlight)]",
})``;

export const DashboardGridLayoutQuaternary = styled.div.attrs({
  className: "mt-8 grid gap-6 xl:grid-cols-[1fr_1.1fr]",
})``;

export const DashboardMetaTextTertiary = styled.p.attrs({
  className: "mt-1 text-xs text-[var(--brand-muted)]",
})``;

export const DashboardGridLayoutQuinary = styled.div.attrs({
  className: "mt-8 grid gap-6 xl:grid-cols-[1.1fr_0.9fr]",
})``;

export const DashboardGridLayoutSenary = styled.div.attrs({ className: "grid gap-4" })``;

export const DashboardSecondaryButtonSecondary = styled.button.attrs({
  className: "brand-button-secondary",
})``;

export const DashboardBodyText = styled.p.attrs({
  className: "text-sm leading-6 text-[var(--brand-muted)]",
})``;

export const DashboardGridLayoutSeptenary = styled.div.attrs({
  className: "mt-8 grid gap-6 xl:grid-cols-[0.95fr_1.05fr]",
})``;

export const DashboardGridLayoutOctonary = styled.div.attrs({
  className: "grid gap-4 md:grid-cols-[220px_1fr]",
})``;

export const DashboardHeroImage = styled(FallbackImage).attrs({
  className: "aspect-square w-full rounded-[24px]",
})``;

export const DashboardEyebrowText = styled.p.attrs({
  className: "text-xs uppercase tracking-[0.2em] text-[var(--brand-muted)]",
})``;

export const DashboardTitleText = styled.p.attrs({
  className: "mt-2 text-lg font-medium text-[var(--brand-ink)]",
})``;

export const DashboardEmptyStatePanel = styled.div.attrs({
  className:
    "mt-4 rounded-2xl border border-dashed border-[var(--brand-border)] bg-[var(--brand-bg)]/50 px-4 py-4 text-sm leading-6 text-[var(--brand-muted)]",
})``;

export const DashboardGridLayoutNonary = styled.div.attrs({
  className: "mt-8 grid gap-6 xl:grid-cols-2",
})``;

export const DashboardGridLayoutDenary = styled.div.attrs({
  className: "mt-8 grid gap-6 xl:grid-cols-[1.05fr_0.95fr]",
})``;

export const DashboardGridLayoutAlpha = styled.div.attrs({
  className: "mt-8 grid gap-6 xl:grid-cols-[0.85fr_1.15fr]",
})``;

export const DashboardContentStack = styled.div.attrs({ className: "space-y-4" })``;

export const DashboardFieldSelect = styled.select.attrs({ className: "brand-input" })``;

export const DashboardGridLayoutBeta = styled.div.attrs({
  className: "grid gap-3 sm:grid-cols-2",
})``;

export const DashboardPanelCard = styled.div.attrs({
  className:
    "rounded-[24px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] p-4 shadow-[0_18px_28px_rgba(0,0,0,0.2)] sm:col-span-2",
})``;

export const DashboardInfoRowSecondary = styled.div.attrs({
  className: "flex items-center gap-4",
})``;

export const DashboardPreviewImage = styled(FallbackImage).attrs({
  className: "h-16 w-16 shrink-0 rounded-[20px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] shadow-[0_12px_20px_rgba(0,0,0,0.18)]",
})``;

export const DashboardTextGroup = styled.div.attrs({ className: "min-w-0" })``;

export const DashboardTitleTextSecondary = styled.p.attrs({
  className: "mt-1 truncate text-lg font-semibold text-[var(--brand-ink)]",
})``;

export const DashboardPanelCardSecondary = styled.div.attrs({
  className:
    "rounded-[24px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] p-4 shadow-[0_18px_28px_rgba(0,0,0,0.2)]",
})``;

export const DashboardSectionSecondary = styled.div.attrs({ className: "mt-3" })``;

export const DashboardInlineText = styled.span.attrs({
  className:
    "inline-flex items-center rounded-full bg-emerald-50 px-3 py-1 text-sm font-medium capitalize text-emerald-700",
})``;

export const DashboardTextBlock = styled.p.attrs({
  className: "mt-2 text-2xl font-semibold text-[var(--brand-ink)]",
})``;

export const DashboardPanelCardTertiary = styled.div.attrs({
  className:
    "rounded-[24px] border border-[var(--brand-border)] bg-[var(--brand-bg)]/60 p-4 sm:col-span-2",
})``;

export const DashboardBodyTextSecondary = styled.p.attrs({
  className: "mt-2 text-sm leading-6 text-[var(--brand-muted)]",
})``;

export const DashboardContentStackSecondary = styled.div.attrs({ className: "space-y-3" })``;

export const DashboardHeaderRow = styled.div.attrs({
  className: "flex items-center justify-between",
})``;

export const DashboardSectionArticle = styled.article.attrs({
  className:
    "rounded-[24px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] p-4 shadow-[0_18px_28px_rgba(0,0,0,0.2)]",
})``;

export const DashboardSectionTertiary = styled.div.attrs({ className: "flex items-start gap-3" })``;

export const DashboardPreviewImageSecondary = styled(FallbackImage).attrs({
  className: "h-14 w-14 shrink-0 rounded-[18px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] shadow-[0_12px_20px_rgba(0,0,0,0.18)]",
})``;

export const DashboardSectionQuaternary = styled.div.attrs({ className: "min-w-0 flex-1" })``;

export const DashboardTextBlockSecondary = styled.p.attrs({
  className: "truncate text-base font-semibold text-[var(--brand-ink)]",
})``;

export const DashboardMetaTextQuaternary = styled.p.attrs({
  className: "mt-1 text-sm text-[var(--brand-muted)]",
})``;

export const DashboardEyebrowTextSecondary = styled.p.attrs({
  className: "mt-2 text-xs uppercase tracking-[0.2em] text-[var(--brand-muted)]",
})``;

export const DashboardSectionQuinary = styled.div.attrs({
  className: "mt-4 flex flex-wrap gap-2",
})``;

export const DashboardStatusBadge = styled.span.attrs({
  className:
    "inline-flex items-center rounded-full bg-[var(--brand-bg)] px-3 py-1 text-xs font-medium text-[var(--brand-highlight)]",
})``;

export const DashboardSectionSenary = styled.div.attrs({ className: "h-12 w-12 shrink-0" })``;

export const DashboardSectionSeptenary = styled.div.attrs({ className: "flex flex-wrap gap-3" })``;

export const DashboardGridLayoutGamma = styled.div.attrs({
  className: "grid gap-4 md:grid-cols-2",
})``;

export const DashboardSectionOctonary = styled.div.attrs({ className: "flex flex-wrap gap-2" })``;

export const DashboardStatusBadgeSecondary = styled.span.attrs({
  className:
    "inline-flex items-center gap-2 rounded-full border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-3 py-1.5 text-xs text-[var(--brand-muted)]",
})``;

export const DashboardInlineTextSecondary = styled.span.attrs({
  className: "font-medium text-[var(--brand-ink)]",
})``;

export const DashboardGridLayoutDelta = styled.div.attrs({ className: "grid gap-3" })``;

export const DashboardContentStackTertiary = styled.div.attrs({ className: "space-y-5" })``;

export const DashboardPulseSection = styled.div.attrs({
  className: "mt-8",
})``;

export const DashboardSchoolContextRow = styled.div.attrs({
  className:
    "mb-6 flex min-w-0 flex-col gap-3 sm:flex-row sm:items-center sm:justify-between",
})``;

export const DashboardSchoolContextActions = styled.div.attrs({
  className: "flex shrink-0 flex-wrap items-center gap-2 sm:justify-end",
})``;

export const DashboardSchoolPrimaryButton = styled.button.attrs({
  className:
    "rounded-2xl bg-[var(--brand-highlight)] px-4 py-3 text-sm font-semibold text-[#1b1306] transition hover:bg-[var(--brand-accent-deep)] hover:text-white",
})``;

export const DashboardToolbarRow = styled.div.attrs({
  className:
    "mb-6 flex min-w-0 flex-col gap-3 sm:flex-row sm:items-center sm:justify-between",
})``;

export const DashboardToolbarTitle = styled.h1.attrs({
  className:
    "min-w-0 truncate text-xl font-semibold leading-tight text-[var(--brand-ink)] sm:text-2xl",
})``;

export const DashboardToolbarActions = styled.div.attrs({
  className: "flex shrink-0 flex-wrap items-center gap-2 sm:justify-end",
})``;

export const DashboardShortcutGrid = styled.div.attrs({
  className: "grid gap-3 sm:grid-cols-2 xl:grid-cols-3",
})``;

export const DashboardShortcutButton = styled.button.attrs({
  className:
    "flex items-center justify-between gap-3 rounded-2xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-4 py-3 text-left text-sm font-medium text-[var(--brand-ink)] transition hover:border-[var(--brand-highlight)] hover:bg-[rgba(240,191,86,0.08)]",
})``;

export const DashboardShortcutMeta = styled.span.attrs({
  className: "shrink-0 text-xs font-normal text-[var(--brand-muted)]",
})``;

export const DashboardFixtureList = styled.div.attrs({
  className: "grid max-h-[22rem] gap-2 overflow-y-auto pr-1",
})``;

export const DashboardFixtureRow = styled.button.attrs({
  className:
    "grid w-full gap-1 rounded-2xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-3.5 py-3 text-left transition hover:border-[var(--brand-highlight)] hover:bg-[rgba(240,191,86,0.08)]",
})``;

export const DashboardFixtureRowStatic = styled.div.attrs({
  className:
    "grid w-full gap-1 rounded-2xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-3.5 py-3",
})``;

export const DashboardFixtureTitle = styled.p.attrs({
  className: "truncate text-sm font-medium text-[var(--brand-ink)]",
})``;

export const DashboardFixtureMeta = styled.p.attrs({
  className: "truncate text-xs text-[var(--brand-muted)]",
})``;


